import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=5e79790c&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=5e79790c&prod&lang=scss&scoped=true"
import style1 from "./PageTitle.vue?vue&type=style&index=1&id=5e79790c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e79790c",
  null
  
)

export default component.exports